import React, {useState, useEffect} from "react";
import SVG_UncheckIcon from '../../assets/images/svgs/validation_uncheck.svg?react';
import SVG_CheckIcon from '../../assets/images/svgs/validation_check.svg?react';

const PasswordValidation = ({open, setOpen, password}) => {
    const [animateClass, setAnimateClass] = useState('scaleVerticalOpen');
    const [validations, setValidations] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false,
    });

    const validatePassword = (password) => {
        setValidations({
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        });
    };

    useEffect(() => {
        validatePassword(password);
    }, [password]);

    useEffect(() => {
        if(!validations.length || !validations.uppercase || !validations.lowercase || !validations.number || !validations.specialChar) {
            setAnimateClass('scaleVerticalOpen');
            if(!open) setOpen(true);
        }else {
            setAnimateClass('scaleVerticalClose');
            setTimeout(() => {
                setOpen(false);
            }, 200);
            
        }
    }, [validations])


    if(!open) {
        return null;
    }

    return (
        <div
            className={` absolute z-[9] bg-bg_Quaternary w-full p-2 origin-top  top-[110%] rounded-t-none drop-shadow-lg ${animateClass}`}
            style={{borderRadius: '10px'}}
        >
            <div className="grid grid-cols-12 items-start justify-start mb-1 text-justify">
                <div className=" col-span-1 rounded-full h-full flex items-start mt-1 justify-center">
                    {(validations.length)? <SVG_CheckIcon /> : <SVG_UncheckIcon />}
                </div>
                <p className={` col-span-10 text-xs sm:text-sm font-lato ${validations.length? 'text-text_Success opacity-100' : 'text-text_Ternary  opacity-95'}`}>
                    Must be atleast 6 characters.
                </p>
            </div>
            {/* <div className="grid grid-cols-12 items-start justify-start mb-1 text-justify">
                <div className=" col-span-1 rounded-full h-full flex items-start mt-1 justify-center">
                    {(validations.uppercase)? <SVG_CheckIcon /> : <SVG_UncheckIcon />}
                </div>
                <p className={` col-span-10 text-xs sm:text-sm font-lato ${validations.uppercase? 'text-text_Success opacity-100' : 'text-text_Ternary  opacity-95'}`}>
                    Must contain at least one uppercase letter.
                </p>
            </div>
            <div className="grid grid-cols-12 items-start justify-start mb-1 text-justify">
                <div className=" col-span-1 rounded-full h-full flex items-start mt-1 justify-center">
                    {(validations.lowercase)? <SVG_CheckIcon /> : <SVG_UncheckIcon />}
                </div>
                <p className={` col-span-10 text-xs sm:text-sm font-lato ${validations.lowercase? 'text-text_Success opacity-100' : 'text-text_Ternary  opacity-95'}`}>
                    Must contain at least one lowercase letter.
                </p>
            </div>
            <div className="grid grid-cols-12 items-start justify-start mb-1 text-justify">
                <div className=" col-span-1 rounded-full h-full flex items-start mt-1 justify-center">
                    {(validations.number)? <SVG_CheckIcon /> : <SVG_UncheckIcon />}
                </div>
                <p className={` col-span-10 text-xs sm:text-sm font-lato ${validations.number? 'text-text_Success opacity-100' : 'text-text_Ternary  opacity-95'}`}>
                    Must contain at least one number.
                </p>
            </div>
            <div className="grid grid-cols-12 items-start justify-start mb-1 text-justify">
                <div className=" col-span-1 rounded-full h-full flex items-start mt-1 justify-center">
                    {(validations.specialChar)? <SVG_CheckIcon /> : <SVG_UncheckIcon />}
                </div>
                <p className={` col-span-10 text-xs sm:text-sm font-lato ${validations.specialChar? 'text-text_Success opacity-100' : 'text-text_Ternary  opacity-95'}`}>
                    Must contain at least one special character.
                </p>
            </div> */}
        </div>
    );
};

export default PasswordValidation;
